import RestultsStates from './classes/ResultsStates';


const Scores = ({resultsStates}:{resultsStates:RestultsStates}) =>{

	var incorrectColor = 'black';
	if (resultsStates.inCorrect > 0) {
		incorrectColor = 'red';
	}

	return (
		<>
			<div className="text-center mt-4">
				<h3 style={{color:'green'}}>correct: {resultsStates.correct}</h3>
				<h4 style={{color:incorrectColor}}>incorrect: {resultsStates.inCorrect}</h4>
				<h4>Total: {resultsStates.total}</h4>
			</div>
		</>
	)
}

export default Scores;